import i1 from '../Pages/Home/gk.jpg';
import i2 from '../Pages/Home/book.png';
import i3 from '../Pages/Home/film.png';
import i4 from '../Pages/Home/music.png';
import i5 from '../Pages/Home/MT.png';
import i6 from '../Pages/Home/tele.png';
import i7 from '../Pages/Home/vg.png';
import i8 from '../Pages/Home/bg.png';
import i9 from '../Pages/Home/SN.png';
import i10 from '../Pages/Home/comp.png';
import i11 from '../Pages/Home/math.png';
import i12 from '../Pages/Home/myth.jpg';
import i13 from '../Pages/Home/sport.png';
import i14 from '../Pages/Home/geo.png';
import i15 from '../Pages/Home/history.png';
import i16 from '../Pages/Home/politic.png';
import i17 from '../Pages/Home/celeb.png';
import i18 from '../Pages/Home/animal.png';
import i19 from '../Pages/Home/vehicle.png';
import i20 from '../Pages/Home/comic.png';
import i21 from '../Pages/Home/gadget.png';
import i22 from '../Pages/Home/jap.png';
import i23 from '../Pages/Home/CA.png';

const Categories = [
    {category: "General Knowledge",value: 9 ,i: i1},
    { category: "Books", value: 10 ,i: i2},
    { category: "Films", value: 11 ,i: i3},
    { category: "Music", value: 12 ,i: i4},
    { category: "Musicals and Theaters", value: 13, i: i5},
    { category: "Television", value: 14 ,i: i6},
    { category: "Video Games", value: 15, i: i7 },
    { category: "Board Games", value: 16,i: i8 },
    { category: "Science and Nature", value: 17,i: i9 },
    { category: "Computer", value: 18,i: i10 },
    { category: "Mathematics", value: 19,i: i11 },
    { category: "Mythology", value: 20,i: i12 },
    { category: "Sports", value: 21 ,i: i13},
    { category: "Geography", value: 22 ,i: i14},
    { category: "History", value: 23,i: i15 },
    { category: "Politics", value: 24 ,i: i16},
    { category: "Celebrities", value: 26 ,i: i17},
    { category: "Animals", value: 27 ,i: i18},
    { category: "Vehicles", value: 28 ,i: i19},
    { category: "Comics", value: 29 ,i: i20},
    { category: "Gadgets", value: 30 ,i: i21},
    { category: "Japanese Anime", value: 31 ,i: i22},
    { category: "Cartoon and Animations", value: 32 ,i: i23},
  ];
  
  export default Categories;